var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnWirelessLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.3269,
    y: 26.5127,
    width: 4.65385,
    height: 4.65385,
    rx: 2.32692,
    transform: "rotate(90 24.3269 26.5127)",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.4913C23.2087 19.4913 24.357 19.7133 25.4451 20.1571C26.5332 20.601 27.5202 21.2114 28.4059 21.9882C28.7282 22.2656 28.8935 22.6311 28.9019 23.0846C28.9103 23.5381 28.7691 23.9309 28.4784 24.2631C28.2044 24.5775 27.866 24.7395 27.4631 24.7492C27.0602 24.7588 26.6976 24.6337 26.3753 24.3741C25.7629 23.8932 25.0861 23.514 24.3448 23.2366C23.6035 22.9592 22.8219 22.8205 22 22.8205C21.1781 22.8205 20.3965 22.9592 19.6552 23.2366C18.9139 23.514 18.2371 23.8932 17.6247 24.3741C17.3024 24.633 16.9398 24.7532 16.5369 24.7347C16.134 24.7162 15.7956 24.5498 15.5216 24.2354C15.2477 23.9024 15.1107 23.5096 15.1107 23.0568C15.1107 22.6041 15.2718 22.2386 15.5941 21.9604C16.4805 21.1836 17.4677 20.5777 18.5558 20.1427C19.6439 19.7077 20.792 19.4906 22 19.4913ZM22 12.833C24.0144 12.833 25.9122 13.2122 27.6932 13.9705C29.4743 14.7288 31.0736 15.8015 32.4911 17.1887C32.8134 17.5031 32.9826 17.8915 32.9987 18.3539C33.0148 18.8162 32.8779 19.2139 32.5878 19.5468C32.3138 19.8612 31.9754 20.0232 31.5725 20.0329C31.1696 20.0425 30.807 19.899 30.4847 19.6023C29.3244 18.5111 28.0233 17.6651 26.5813 17.0644C25.1393 16.4636 23.6122 16.1629 22 16.1622C20.3878 16.1614 18.8611 16.4622 17.4197 17.0644C15.9783 17.6666 14.6769 18.5125 13.5153 19.6023C13.193 19.8982 12.8304 20.0417 12.4275 20.0329C12.0246 20.024 11.6862 19.862 11.4122 19.5468C11.1221 19.2139 10.9852 18.8162 11.0013 18.3539C11.0174 17.8915 11.1866 17.5031 11.5089 17.1887C12.9271 15.8015 14.5267 14.7288 16.3077 13.9705C18.0888 13.2122 19.9862 12.833 22 12.833Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnWirelessLight);
export default __webpack_public_path__ + "static/media/btn_wireless_light.a2c4c08e0096b81a489ca60b40744d6b.svg";
export { ForwardRef as ReactComponent };